import React from 'react';
import spinner from '../images/spinner.png';

export const Spinner = () => {
	return(
		<img className="spinner" src={spinner} alt="loading..."/>
	)
}